export const getEntityAvatarName = (member: {
  name?: string
  firstName?: string
  lastName?: string
  email?: string
}): string => {
  if (member.name) return member.name
  if (member.firstName && member.lastName) return `${member.firstName} ${member.lastName}`
  if (member.firstName) return member.firstName
  if (member.lastName) return member.lastName
  if (member.email) return member.email
  return ''
}
